import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// Import Swiper React components and required styles
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default function ReviewsAndStats() {
  // Testimonial data array
  const testimonials = [
    {
      text: "Amazing template, Redux store and components is nicely designed. It's a great start point for an admin based project. Clean Code and good documentation. Template is completely in React and absolutely no usage of jQuery",
      user: "sreeks456",
      role: "TSM User"
    },
    {
      text: "The code quality is excellent and the support team responds incredibly fast. It saved us hundreds of hours of development time building our dashboard framework.",
      user: "theme_dev",
      role: "TSM User"
    },
    {
      text: "The code quality is excellent and the support team responds incredibly fast. It saved us hundreds of hours of development time building our dashboard framework.",
      user: "theme_dev",
      role: "TSM User"
    },
    {
      text: "The code quality is excellent and the support team responds incredibly fast. It saved us hundreds of hours of development time building our dashboard framework.",
      user: "theme_dev",
      role: "TSM User"
    },
    {
      text: "The code quality is excellent and the support team responds incredibly fast. It saved us hundreds of hours of development time building our dashboard framework.",
      user: "theme_dev",
      role: "TSM User"
    },
    {
      text: "The code quality is excellent and the support team responds incredibly fast. It saved us hundreds of hours of development time building our dashboard framework.",
      user: "theme_dev",
      role: "TSM User"
    }
  ];

  // Counter numbers layout data
  const statsData = [
    { number: "10+", label: "Projects Completed" },
    { number: "2+", label: "Win Awards" },
    { number: "19k", label: "Satisfied Clients" },
    { number: "18+", label: "Employees" }
  ];

  return (
    <>
      {/* 1. TOP SECTION: Blue Slider Panel */}
      <section id="stats"
        className="py-5 text-white text-center position-relative" 
        style={{ backgroundColor: '#2c3e6b', minHeight: '400px' }}
      >
        <Container className="py-5">
          {/* Green Quote Mark */}
          <div className="display-1 text-success lh-1 mb-2">“</div>
          
          <h5 className="text-light fw-medium mb-5">
            <span className="text-success fw-bold">19k+</span> Satisfied clients
          </h5>

          {/* Swiper Slider Configuration */}
          <Swiper
            modules={[Pagination, Navigation]}
            slidesPerView={1}
            loop={true}
            pagination={{ clickable: true, el: '.custom-swiper-pagination' }}
            navigation={{ nextEl: '.custom-next', prevEl: '.custom-prev' }}
            className="w-100 max-width-md mx-auto"
            style={{ maxWidth: '750px' }}
          >
            {testimonials.map((t, idx) => (
              <SwiperSlide key={idx} className="px-5">
                <p className="fs-5 lh-lg text-light opacity-75 mb-4 px-md-4">
                  " {t.text} "
                </p>
                <h6 className="fw-bold mb-1 text-white">{t.user}</h6>
                <small className="text-light opacity-50 d-block mb-4">— {t.role}</small>
              </SwiperSlide>
            ))}

            {/* Custom Navigation Target Elements */}
            <div className="custom-prev position-absolute top-50 start-0 translate-middle-y z-3 cursor-pointer d-flex align-items-center justify-content-center bg-white rounded-circle text-dark shadow" style={{ width: '40px', height: '40px', left: '15px' }}>
              <i className="bi bi-chevron-left"></i>
            </div>
            <div className="custom-next position-absolute top-50 end-0 translate-middle-y z-3 cursor-pointer d-flex align-items-center justify-content-center bg-white rounded-circle text-dark shadow" style={{ width: '40px', height: '40px', right: '15px' }}>
              <i className="bi bi-chevron-right"></i>
            </div>

            {/* Custom Pagination Target Indicator */}
            <div className="custom-swiper-pagination d-flex justify-content-center gap-2 mt-2"></div>
          </Swiper>
        </Container>
      </section>

      {/* 2. BOTTOM SECTION: Counter Numbers Grid Bar */}
      <section className="py-5 bg-light border-bottom">
        <Container>
          <Row className="text-center g-4">
            {statsData.map((stat, i) => (
              <Col key={i} xs={6} md={3}>
                <h2 className="display-6 fw-bold text-dark mb-2">
                  {stat.number}
                </h2>
                <p className="text-secondary mb-0 fs-6 fw-medium">
                  {stat.label}
                </p>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
}
